// extracted by mini-css-extract-plugin
export default {"item":"TableProductItem_item__JI+7q","bodyColumn":"TableProductItem_bodyColumn__YVsev"};